export default {
  welcome: 'Bienvenue',
  beeText1: 'Bzz... Voulez-vous que je vous aide à créer des tâches ?',
  beeText2:
    'Jetez un œil au champ de texte ci-dessous. il vous donnera quelques indices sur la façon de commencer',
  beeText3: 'Bzzz... Je suis une abeille occupée, mais je peux vous aider à créer des tâches',
  task: 'Tâche',
  taskExample1: 'Nettoyer la salle de bain',
  taskExample2: 'Préparation des repas',
  taskExample3: 'Course au supermarché',
  taskExample4: 'Lessive',
}
